import request from '@/utils/request'

export const getBucketGiftTierList = (params?: { storeId?: number }) =>
  request({
    url: '/waterVoucher/giftTier/list',
    method: 'get',
    params
  })

export const addBucketGiftTier = (data: any) =>
  request({
    url: '/waterVoucher/giftTier',
    method: 'post',
    data
  })

export const updateBucketGiftTier = (data: any) =>
  request({
    url: '/waterVoucher/giftTier',
    method: 'put',
    data
  })

export const deleteBucketGiftTier = (id: number) =>
  request({
    url: `/waterVoucher/giftTier/${id}`,
    method: 'delete'
  })

export const setBucketGiftTierEnabled = (id: number, enabled: number) =>
  request({
    url: `/waterVoucher/giftTier/${id}/enabled`,
    method: 'put',
    params: { enabled }
  })

export const bucketGiftTierMoveSort = (params: { id: number | string; direction: 'up' | 'down' }) =>
  request({
    url: `/waterVoucher/giftTier/sort/${params.direction}`,
    method: 'post',
    params: { id: params.id }
  })

export const bucketGiftTierSetSort = (params: { id: number | string; sort: number }) =>
  request({
    url: `/waterVoucher/giftTier/sort`,
    method: 'post',
    params: { id: params.id, sort: params.sort }
  })
